import React, { useState } from 'react';
import EnhancedSEO from '../../Components/SEO/EnhancedSEO';


const TermsOfServicePage = () => {
  const [expandedSection, setExpandedSection] = useState('overview');
  const [showSection, setShowSection] = useState(false); // Flag to control team section visibility
  

  const handleAccordionToggle = (sectionId) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 16px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 1.5,
    color: '#212121'
  };

  const headerStyle = {
    background: 'linear-gradient(135deg, #d32f2f 0%, #c62828 100%)',
    color: 'white',
    padding: '32px',
    borderRadius: '8px',
    marginBottom: '32px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  };

  const paperStyle = {
    backgroundColor: '#fff',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    marginBottom: '16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
  };

  const accordionStyle = {
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    marginBottom: '8px',
    overflow: 'hidden'
  };

  const accordionHeaderStyle = {
    padding: '16px',
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    transition: 'background-color 0.2s'
  };

  const accordionContentStyle = {
    padding: '24px',
    borderTop: '1px solid #e0e0e0'
  };

  const chipStyle = {
    display: 'inline-block',
    padding: '6px 12px',
    margin: '4px',
    borderRadius: '16px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s'
  };

  const cardStyle = {
    backgroundColor: '#f5f5f5',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #e0e0e0'
  };

  const alertStyle = {
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #e3f2fd',
    backgroundColor: '#e3f2fd',
    color: '#1976d2'
  };

  const warningAlertStyle = {
    ...alertStyle,
    border: '1px solid #fff3e0',
    backgroundColor: '#fff3e0',
    color: '#f57c00'
  };

  const errorAlertStyle = {
    ...alertStyle,
    border: '1px solid #ffebee',
    backgroundColor: '#ffebee',
    color: '#d32f2f'
  };

  const buttonStyle = {
    padding: '12px 24px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    margin: '4px',
    transition: 'all 0.2s'
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#d32f2f',
    color: 'white'
  };

  const outlinedButtonStyle = {
    ...buttonStyle,
    backgroundColor: 'transparent',
    color: '#d32f2f',
    border: '1px solid #d32f2f'
  };

  const sections = [
    {
      id: 'overview',
      title: 'Agreement Overview',
      icon: '📋',
      color: '#d32f2f',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Welcome to Revfer! These Terms of Service ("Terms") govern your use of our community-driven business review and referral platform. By accessing or using Revfer, you agree to be bound by these Terms.
          </p>
          
          <div style={errorAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0', fontSize: '16px' }}>
              Important Legal Agreement
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These Terms constitute a legally binding agreement between you and Revfer Inc. Please read them carefully before using our services.
            </p>
          </div>

          <h3 style={{ marginTop: '24px', marginBottom: '16px', color: '#d32f2f' }}>
            Key Points:
          </h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginTop: '16px' }}>
            <div style={{ ...cardStyle, backgroundColor: '#ffebee', color: '#d32f2f' }}>
              <h4 style={{ margin: '0 0 8px 0' }}>Acceptance Required</h4>
              <p style={{ margin: 0, fontSize: '14px' }}>By using Revfer, you agree to these Terms and our Privacy Policy</p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#e3f2fd', color: '#1976d2' }}>
              <h4 style={{ margin: '0 0 8px 0' }}>Age Requirement</h4>
              <p style={{ margin: 0, fontSize: '14px' }}>You must be 18 or older to use our services</p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#e8f5e8', color: '#388e3c' }}>
              <h4 style={{ margin: '0 0 8px 0' }}>Community Standards</h4>
              <p style={{ margin: 0, fontSize: '14px' }}>All users must follow our community guidelines</p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#fff3e0', color: '#f57c00' }}>
              <h4 style={{ margin: '0 0 8px 0' }}>Updates Apply</h4>
              <p style={{ margin: 0, fontSize: '14px' }}>Changes to Terms take effect upon posting</p>
            </div>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Last Updated: June 4, 2025
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Material changes to these Terms will be communicated via email and prominent platform notices 30 days before taking effect.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'accounts',
      title: 'Account Requirements & Responsibilities',
      icon: '👤',
      color: '#1976d2',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Your account is the foundation of your Revfer experience. Here are the requirements and your responsibilities:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Account Creation Requirements</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Age:</strong> You must be at least 18 years old</li>
              <li><strong>Identity:</strong> Provide accurate, complete, and current information</li>
              <li><strong>Verification:</strong> Complete any required verification processes</li>
              <li><strong>Single Account:</strong> One account per person (no duplicate accounts)</li>
              <li><strong>Authorization:</strong> You must have authority to enter into this agreement</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Account Security</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Maintain the confidentiality of your login credentials</li>
              <li>Use strong passwords and enable two-factor authentication when available</li>
              <li>Immediately notify us of any unauthorized account access</li>
              <li>You are responsible for all activities under your account</li>
              <li>We may require additional verification for sensitive actions</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Business Accounts</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Business representatives must have authority to act on behalf of their business</li>
              <li>All business information must be accurate and regularly updated</li>
              <li>You may claim only businesses you own or are authorized to represent</li>
              <li>Business verification may be required for enhanced features</li>
              <li>Premium business accounts are subject to additional terms</li>
            </ul>
          </div>

          <div style={errorAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Account Suspension & Termination
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              We may suspend or terminate accounts that violate these Terms, engage in fraudulent activity, 
              or pose risks to our community. You may also terminate your account at any time through your account settings.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'platform-use',
      title: 'Platform Use & Community Guidelines',
      icon: '🌐',
      color: '#388e3c',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Revfer is built on trust and authentic community engagement. Here's how you should use our platform:
          </p>

          <div style={{ ...cardStyle, backgroundColor: '#e8f5e8', color: '#388e3c' }}>
            <h4 style={{ marginBottom: '12px' }}>Permitted Uses</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Write honest, authentic reviews based on your personal experience</li>
              <li>Search for and discover local businesses</li>
              <li>Build trust networks with verified connections</li>
              <li>Follow businesses and receive updates</li>
              <li>Participate in community verification activities</li>
              <li>Use AI-assisted features to enhance your content</li>
              <li>Engage in Q&A discussions about businesses</li>
            </ul>
          </div>

          <div style={{ ...cardStyle, backgroundColor: '#ffebee', color: '#d32f2f' }}>
            <h4 style={{ marginBottom: '12px' }}>Prohibited Activities</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Fake Reviews:</strong> Writing reviews for businesses you haven't used or visited</li>
              <li><strong>Review Manipulation:</strong> Coordinating fake reviews or gaming the rating system</li>
              <li><strong>Spam & Harassment:</strong> Sending unsolicited messages or harassing other users</li>
              <li><strong>Fraudulent Identity:</strong> Impersonating others or creating fake profiles</li>
              <li><strong>Commercial Exploitation:</strong> Using the platform for unauthorized advertising</li>
              <li><strong>Data Scraping:</strong> Automated collection of platform data</li>
              <li><strong>System Interference:</strong> Attempting to disrupt platform functionality</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#f57c00' }}>Content Standards</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Keep content relevant, helpful, and constructive</li>
              <li>Respect intellectual property rights</li>
              <li>No hate speech, discrimination, or offensive content</li>
              <li>Protect privacy - don't share personal information of others</li>
              <li>Use appropriate language suitable for all audiences</li>
              <li>Support claims with facts when making serious allegations</li>
            </ul>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Enforcement & Consequences
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Violations may result in content removal, account restrictions, suspension, or termination. 
              We reserve the right to investigate violations and take appropriate action to protect our community.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'content-reviews',
      title: 'Reviews, Content & AI Usage',
      icon: '⭐',
      color: '#f57c00',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Your reviews and content make Revfer valuable for everyone. Here are the rules governing content creation and AI assistance:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Review Guidelines</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Personal Experience:</strong> Only review businesses you've personally interacted with</li>
              <li><strong>Honesty Required:</strong> Provide truthful, balanced assessments</li>
              <li><strong>Specific Details:</strong> Include relevant details about your experience</li>
              <li><strong>Recent Experience:</strong> Reviews should reflect recent interactions when possible</li>
              <li><strong>Fair Criticism:</strong> Criticism should be constructive and fact-based</li>
              <li><strong>No Conflicts:</strong> Disclose any personal or business relationships</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>AI-Assisted Content</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>AI assistance is available to help you write comprehensive reviews</li>
              <li>You maintain full ownership and responsibility for published content</li>
              <li>AI-generated content must be reviewed and approved by you before publishing</li>
              <li>You may not use AI to create fake or misleading reviews</li>
              <li>AI processing is subject to our Privacy Policy and third-party AI provider terms</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Content Ownership & Licensing</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>You retain ownership of your original content</li>
              <li>By posting, you grant Revfer a license to display, distribute, and use your content</li>
              <li>This license includes processing for AI embeddings and search functionality</li>
              <li>You may edit or delete your content, subject to technical limitations</li>
              <li>Some content may remain in caches or backups after deletion</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#f57c00' }}>Trust Network & Verification</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Trust connections should reflect real relationships</li>
              <li>Participate honestly in community verification activities</li>
              <li>Don't manipulate trust scores or verification systems</li>
              <li>Report suspicious or fraudulent verification activities</li>
              <li>Understand that trust data may be used in algorithmic assessments</li>
            </ul>
          </div>

          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Content Moderation
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              We reserve the right to review, edit, or remove content that violates these Terms or 
              community standards. We also use automated systems to detect policy violations.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'business-terms',
      title: 'Business Services & Commercial Use',
      icon: '🏢',
      color: '#7b1fa2',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Additional terms apply to businesses using Revfer for commercial purposes:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Business Profile Requirements</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Provide accurate business information including name, address, and contact details</li>
              <li>Maintain current business hours, services, and other relevant information</li>
              <li>Use only authorized photos and content you have rights to</li>
              <li>Respond promptly to verification requests</li>
              <li>Update information when business details change</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Review Response Guidelines</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Respond professionally and constructively to customer reviews</li>
              <li>Address legitimate concerns and thank customers for feedback</li>
              <li>Don't ask customers to remove or modify reviews</li>
              <li>Don't offer incentives for positive reviews</li>
              <li>Respect customer privacy in your responses</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Premium Business Services</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Premium subscriptions are billed according to your chosen plan</li>
              <li>Enhanced analytics and promotion tools are included</li>
              <li>Subscription fees are non-refundable except as required by law</li>
              <li>We may modify pricing with 30 days notice</li>
              <li>Cancellation takes effect at the end of your billing period</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#f57c00' }}>Document Upload & Processing</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Only upload documents you have rights to share</li>
              <li>Documents may be processed for AI search and analysis</li>
              <li>Ensure documents don't contain confidential customer information</li>
              <li>We may limit file sizes and types for technical reasons</li>
              <li>You're responsible for document content accuracy and legality</li>
            </ul>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Business Account Restrictions
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Business accounts found manipulating reviews, creating fake profiles, 
              or violating community standards may face immediate suspension and legal action.
            </p>
          </div>

          {/* ===== SMS NOTIFICATIONS — add after Document Upload card ===== */}
          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#0288d1' }}>SMS Notifications</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>
                Premium subscribers may opt in to receive automated SMS notifications
                from Revfer when AI-generated content drafts are ready for approval.
              </li>
              <li>
                SMS notifications are entirely optional. All core
                Revfer features including email notifications and
                draft approvals are available without enabling SMS.
              </li>
              <li>
                By opting in you confirm that you are the mobile account holder or
                have the account holder's permission to enroll the number.
              </li>
              <li>
                Message frequency varies based on your business activity,
                typically 1 to 3 messages per week.
              </li>
              <li>
                To opt out at any time reply STOP to any message or visit your
                notification settings at revfer.com/business/edit. After opting out
                you will receive one final confirmation message.
              </li>
              <li>
                Reply HELP to any message for assistance.
              </li>
              <li>
                Message and data rates may apply. Carriers are not liable for
                delayed or undelivered messages.
              </li>
              <li>
                Revfer is not liable for delays or failures in SMS delivery
                caused by your carrier.
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 'privacy-data',
      title: 'Privacy, Data & Third-Party Services',
      icon: '🔒',
      color: '#0288d1',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Your privacy is important to us. Here's how these Terms relate to our data practices:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Privacy Policy Integration</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Our Privacy Policy is incorporated into these Terms by reference</li>
              <li>Data collection and use are governed by our Privacy Policy</li>
              <li>You consent to data processing as described in our Privacy Policy</li>
              <li>Privacy settings allow you to control visibility of your information</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Third-Party Services</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>OpenAI:</strong> AI processing services for content assistance and embeddings</li>
              <li><strong>AWS:</strong> Cloud hosting, storage, and computing services</li>
              <li><strong>MongoDB:</strong> Database and search services</li>
              <li><strong>Payment Processors:</strong> Billing and subscription management</li>
              <li>Third-party services have their own terms and privacy policies</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Data Portability & Control</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>You can request a copy of your data in a portable format</li>
              <li>Account deletion removes most personal data, subject to legal retention requirements</li>
              <li>Some data may remain in backups or be retained for safety and fraud prevention</li>
              <li>Public content (reviews, ratings) may remain visible after account deletion</li>
            </ul>
          </div>

          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              International Data Transfers
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Your data may be processed in countries outside your residence. 
              We ensure appropriate safeguards for international transfers as described in our Privacy Policy.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'intellectual-property',
      title: 'Intellectual Property Rights',
      icon: '©️',
      color: '#e65100',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Respect for intellectual property is essential to maintaining a trustworthy platform:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Revfer's Intellectual Property</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Revfer platform, software, and design are our proprietary property</li>
              <li>Our trademarks, logos, and brand elements are protected</li>
              <li>Platform algorithms and AI models are proprietary technology</li>
              <li>You may not copy, modify, or distribute our platform code</li>
              <li>Limited license granted for personal, non-commercial use</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>User Content Rights</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>You own the original content you create (reviews, photos, etc.)</li>
              <li>By posting, you grant us rights to use, display, and distribute your content</li>
              <li>This license survives account termination for content that remains on the platform</li>
              <li>You represent that you have rights to all content you upload</li>
              <li>Don't upload copyrighted material without permission</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Copyright Infringement</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>We respect copyright and respond to valid DMCA takedown notices</li>
              <li>Report copyright infringement to: copyright@revfer.com</li>
              <li>Include all required information per DMCA procedures</li>
              <li>Repeat infringers may have their accounts terminated</li>
              <li>Counter-notifications are processed according to DMCA procedures</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#f57c00' }}>Business Names & Trademarks</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Business names and trademarks remain property of their owners</li>
              <li>Platform use doesn't grant trademark rights</li>
              <li>Business owners can claim their official profiles</li>
              <li>Report trademark violations for investigation</li>
              <li>We may remove infringing content upon valid notice</li>
            </ul>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Infringement Consequences
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Users who violate intellectual property rights may face content removal, 
              account suspension, and potential legal action by rights holders.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'disclaimers-liability',
      title: 'Disclaimers & Limitation of Liability',
      icon: '⚖️',
      color: '#795548',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Important legal limitations on our liability and service guarantees:
          </p>

          <div style={{ ...cardStyle, backgroundColor: '#ffebee', color: '#d32f2f' }}>
            <h4 style={{ marginBottom: '12px' }}>Service Disclaimers</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>"As Is" Service:</strong> Revfer is provided without warranties of any kind</li>
              <li><strong>No Guarantees:</strong> We don't guarantee uninterrupted or error-free service</li>
              <li><strong>Content Accuracy:</strong> We don't verify the accuracy of user-generated content</li>
              <li><strong>Third-Party Services:</strong> No warranties for integrated third-party services</li>
              <li><strong>Business Information:</strong> Business details are provided by businesses themselves</li>
            </ul>
          </div>

          <div style={{ ...cardStyle, backgroundColor: '#fff3e0', color: '#f57c00' }}>
            <h4 style={{ marginBottom: '12px' }}>AI Service Limitations</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>AI-generated content may contain errors or inaccuracies</li>
              <li>You're responsible for reviewing and approving AI-assisted content</li>
              <li>AI recommendations are not professional advice</li>
              <li>We don't guarantee AI service availability or accuracy</li>
              <li>AI processing depends on third-party services beyond our control</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Limitation of Liability</h4>
            <p style={{ marginBottom: '8px', fontSize: '14px' }}>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW:
            </p>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Our liability is limited to the amount you paid us in the last 12 months</li>
              <li>We're not liable for indirect, incidental, or consequential damages</li>
              <li>This includes lost profits, data loss, or business interruption</li>
              <li>Limitations apply regardless of the theory of liability</li>
              <li>Some jurisdictions don't allow these limitations</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Indemnification</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>You agree to indemnify Revfer against claims arising from your use</li>
              <li>This includes claims related to your content or Terms violations</li>
              <li>You'll cover legal fees and damages in covered claims</li>
              <li>We'll notify you of claims and may participate in defense</li>
              <li>This survives termination of your account</li>
            </ul>
          </div>

          <div style={errorAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Important Notice
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These limitations are fundamental to our business model and the affordability of our services. 
              If you don't agree with these limitations, you should not use Revfer.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'disputes-legal',
      title: 'Dispute Resolution & Legal Terms',
      icon: '⚖️',
      color: '#424242',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            How disputes are resolved and other important legal provisions:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Governing Law & Jurisdiction</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>These Terms are governed by Massachusetts state law and U.S. federal law</li>
              <li>Disputes will be resolved in state or federal courts in Middlesex County, Massachusetts</li>
              <li>You consent to personal jurisdiction in these courts</li>
              <li>Massachusetts law applies regardless of conflict of law principles</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Arbitration Agreement</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Most disputes must be resolved through binding arbitration</li>
              <li>Arbitration will be conducted by the American Arbitration Association</li>
              <li>Small claims court disputes (under $10,000) may proceed in court</li>
              <li>Class action lawsuits are waived (individual arbitration only)</li>
              <li>You may opt out of arbitration within 30 days of accepting these Terms</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Informal Resolution Process</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Contact us first to try to resolve disputes informally</li>
              <li>Email: disputes@revfer.com with detailed information</li>
              <li>We'll work in good faith to resolve issues within 60 days</li>
              <li>This is required before starting arbitration or court proceedings</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#f57c00' }}>General Legal Provisions</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Severability:</strong> Invalid provisions don't affect the rest of the Terms</li>
              <li><strong>No Waiver:</strong> Our failure to enforce doesn't waive our rights</li>
              <li><strong>Assignment:</strong> We may assign these Terms; you may not without consent</li>
              <li><strong>Entire Agreement:</strong> These Terms and Privacy Policy are the complete agreement</li>
              <li><strong>Survival:</strong> Relevant provisions survive account termination</li>
            </ul>
          </div>

          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Changes to Terms
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              We may modify these Terms periodically. Material changes require 30 days notice. 
              Continued use after changes constitutes acceptance. If you don't agree, discontinue use.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'contact-support',
      title: 'Contact Information & Support',
      icon: '📞',
      color: '#607d8b',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Need help or have questions about these Terms? Here's how to reach us:
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
            <div style={{ ...cardStyle, backgroundColor: '#e3f2fd', color: '#1976d2' }}>
              <h4 style={{ marginBottom: '8px' }}>General Support</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: support@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 24 hours
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For general questions about using Revfer and these Terms.
              </p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#ffebee', color: '#d32f2f' }}>
              <h4 style={{ marginBottom: '8px' }}>Legal & Compliance</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: legal@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 72 hours
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For legal notices, compliance issues, and Terms violations.
              </p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#e8f5e8', color: '#388e3c' }}>
              <h4 style={{ marginBottom: '8px' }}>Business Services</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: business@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 48 hours
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For business account issues, premium services, and partnerships.
              </p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#fff3e0', color: '#f57c00' }}>
              <h4 style={{ marginBottom: '8px' }}>Disputes & Mediation</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: disputes@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 60 days
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For formal dispute resolution before arbitration or legal action.
              </p>
            </div>
          </div>

          <div style={{ ...cardStyle, backgroundColor: '#f5f5f5', marginTop: '24px' }}>
            <h4 style={{ marginBottom: '12px', color: '#424242' }}>Company Information</h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              <strong>Revfer Inc.</strong><br />
              59 Grover Rd<br />
              Ashland, MA 01721<br />
              United States<br /><br />
              <strong>Phone:</strong> +1 (407) 416-9408<br />
            </p>
          </div>

          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Legal Notice Requirements
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Legal notices must be sent to legal@revfer.com or by certified mail to our registered address. 
              Electronic notices to users will be sent to your registered email address.
            </p>
          </div>
        </div>
      )
    }
  ];

  return (
    <>
      {/* 🚀 COMPREHENSIVE SEO OPTIMIZATION WITH STRUCTURED DATA */}
      <EnhancedSEO 
        title="Terms of Service - Revfer | User Agreement, Platform Rules & Legal Terms"
        description="Comprehensive terms of service for Revfer's AI business discovery platform. Legal agreement covering user responsibilities, content guidelines, business services, AI usage terms, intellectual property rights, liability limitations, and dispute resolution for our professional networking community."
        keywords="terms of service, user agreement, platform rules, legal terms, terms and conditions, user responsibilities, community guidelines, business platform terms, AI usage agreement, content policy, intellectual property, liability limitations, dispute resolution, arbitration agreement, professional networking terms, review platform agreement, business service terms, platform liability, user rights obligations"
        type="webpage"
        image="/images/revfer-terms-service-og.jpg"
        author="Revfer Legal Team"
        dateModified="2025-06-04T00:00:00Z"
        datePublished="2024-01-15T00:00:00Z"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Legal', url: '/legal' },
          { name: 'Terms of Service', url: '/legal/terms-of-service' }
        ]}
        organizationData={{
          "@context": "https://schema.org",
          "@type": ["TechnologyCompany", "LegalDocument"],
          "mainEntity": {
            "@type": "TermsOfService",
            "name": "Revfer Terms of Service",
            "description": "Legal agreement governing user access and use of Revfer's AI business discovery platform, including user responsibilities, content guidelines, and service limitations",
            "url": "https://www.revfer.com/legal/terms-of-service",
            "dateModified": "2025-06-04T00:00:00Z",
            "datePublished": "2024-01-15T00:00:00Z",
            "effectiveDate": "2025-06-04T00:00:00Z",
            "publisher": {
              "@type": "Organization",
              "name": "Revfer Inc",
              "url": "https://www.revfer.com",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.revfer.com/logo.png"
              }
            },
            "inLanguage": "en-US",
            "copyrightHolder": {
              "@type": "Organization",
              "name": "Revfer Inc"
            },
            "governingLaw": {
              "@type": "Place",
              "name": "Massachusetts, United States",
              "description": "Terms governed by Massachusetts state law and U.S. federal law"
            },
            "jurisdiction": {
              "@type": "Place", 
              "name": "Middlesex County, Massachusetts",
              "description": "Disputes resolved in state or federal courts in Middlesex County, MA"
            },
            "about": [
              {
                "@type": "Thing",
                "name": "User Account Requirements",
                "description": "Rules for creating and maintaining user accounts"
              },
              {
                "@type": "Thing",
                "name": "Platform Usage Guidelines", 
                "description": "Acceptable use policies and community standards"
              },
              {
                "@type": "Thing",
                "name": "Content and Review Policies",
                "description": "Guidelines for user-generated content and business reviews"
              },
              {
                "@type": "Thing",
                "name": "Business Service Terms",
                "description": "Additional terms for businesses using commercial features"
              },
              {
                "@type": "Thing",
                "name": "AI Usage Agreement",
                "description": "Terms governing AI-assisted features and content generation"
              },
              {
                "@type": "Thing",
                "name": "Liability Limitations",
                "description": "Legal disclaimers and limitation of liability provisions"
              }
            ],
            "mentions": [
              {
                "@type": "Organization",
                "name": "OpenAI",
                "description": "Third-party AI service provider for content assistance"
              },
              {
                "@type": "Organization",
                "name": "Amazon Web Services",
                "description": "Cloud infrastructure and hosting services"
              },
              {
                "@type": "Legislation",
                "name": "Digital Millennium Copyright Act",
                "alternateName": "DMCA",
                "description": "Copyright infringement procedures and takedown notices"
              },
              {
                "@type": "Organization",
                "name": "American Arbitration Association",
                "description": "Dispute resolution and arbitration services"
              }
            ],
            "prohibitedUses": [
              "Fake or fraudulent reviews",
              "Review manipulation or gaming",
              "Spam and harassment",
              "Unauthorized commercial use",
              "Data scraping or automated access",
              "Copyright infringement",
              "System interference or hacking"
            ],
            "userObligations": [
              "Provide accurate account information",
              "Maintain account security",
              "Follow community guidelines",
              "Respect intellectual property rights",
              "Use platform authentically and honestly"
            ]
          },
          "name": "Revfer",
          "alternateName": "Revfer Inc",
          "description": "AI business discovery platform with comprehensive user agreements and community standards",
          "url": "https://www.revfer.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.revfer.com/logo.png",
            "caption": "Revfer AI Platform Logo"
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "59 Grover Rd",
            "addressLocality": "Ashland",
            "addressRegion": "MA",
            "postalCode": "01721", 
            "addressCountry": "US"
          },
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "contactType": "legal support",
              "email": "legal@revfer.com",
              "availableLanguage": "English",
              "description": "Legal notices, compliance issues, and Terms violations"
            },
            {
              "@type": "ContactPoint", 
              "contactType": "dispute resolution",
              "email": "disputes@revfer.com",
              "availableLanguage": "English",
              "description": "Formal dispute resolution before arbitration or legal action"
            },
            {
              "@type": "ContactPoint",
              "contactType": "customer service", 
              "email": "support@revfer.com",
              "availableLanguage": "English",
              "description": "General questions about using Revfer and these Terms"
            },
            {
              "@type": "ContactPoint",
              "contactType": "business services",
              "email": "business@revfer.com", 
              "availableLanguage": "English",
              "description": "Business account issues and premium services"
            }
          ],
          "sameAs": [
            "https://twitter.com/revfer",
            "https://linkedin.com/company/revfer"
          ],
          "knowsAbout": [
            "Terms of Service",
            "User Agreements", 
            "Platform Governance",
            "Community Guidelines",
            "Business Service Terms",
            "AI Usage Policies",
            "Intellectual Property Rights",
            "Dispute Resolution",
            "Legal Compliance",
            "Professional Networking Terms"
          ],
          "termsOfService": "https://www.revfer.com/legal/terms-of-service",
          "privacyPolicy": "https://www.revfer.com/legal/privacy-policy",
          "legalStructure": [
            {
              "@type": "Thing",
              "name": "Binding Agreement",
              "description": "Legally binding contract between users and Revfer Inc"
            },
            {
              "@type": "Thing", 
              "name": "Arbitration Clause",
              "description": "Binding arbitration required for most disputes"
            },
            {
              "@type": "Thing",
              "name": "Limitation of Liability", 
              "description": "Legal limitations on company liability and damages"
            },
            {
              "@type": "Thing",
              "name": "Indemnification",
              "description": "User agreement to indemnify company against certain claims"
            }
          ],
          "serviceTerms": [
            {
              "@type": "Thing",
              "name": "Account Creation",
              "description": "Requirements for creating and maintaining user accounts"
            },
            {
              "@type": "Thing",
              "name": "Content Guidelines",
              "description": "Rules for user-generated content including reviews and ratings"
            },
            {
              "@type": "Thing", 
              "name": "Business Services",
              "description": "Additional terms for business accounts and premium features"
            },
            {
              "@type": "Thing",
              "name": "AI Feature Usage", 
              "description": "Terms governing AI-assisted content generation and processing"
            }
          ]
        }}
        faqData={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What do I agree to by using Revfer?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "By using Revfer, you agree to follow our Terms of Service and Privacy Policy. This includes using the platform authentically, respecting community guidelines, and being at least 18 years old. You're responsible for your account security and all activities under your account."
              }
            },
            {
              "@type": "Question",
              "name": "What are the rules for writing reviews on Revfer?",
              "acceptedAnswer": {
                "@type": "Answer", 
                "text": "Reviews must be based on your personal experience with the business. They should be honest, detailed, and constructive. Fake reviews, review manipulation, and reviews for businesses you haven't used are prohibited. You can use AI assistance, but you're responsible for the final content."
              }
            },
            {
              "@type": "Question",
              "name": "Can my account be suspended or terminated?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, accounts may be suspended or terminated for violating these Terms, engaging in fraudulent activity, or posing risks to our community. This includes fake reviews, harassment, spam, or repeated policy violations. You can also terminate your own account anytime."
              }
            },
            {
              "@type": "Question", 
              "name": "How are disputes with Revfer resolved?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Most disputes must be resolved through binding arbitration with the American Arbitration Association. Small claims under $10,000 may proceed in court. We require informal resolution attempts first by contacting disputes@revfer.com before starting formal proceedings."
              }
            },
            {
              "@type": "Question",
              "name": "What happens to my content if I delete my account?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "You retain ownership of your original content, but Revfer has a license to use content you've posted. When you delete your account, most personal data is removed, but some public content like reviews may remain visible. Some data may persist in backups for technical and legal reasons."
              }
            },
            {
              "@type": "Question",
              "name": "Are there additional terms for business accounts?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, business accounts have additional requirements including providing accurate business information, responding professionally to reviews, and following guidelines for premium services. Business representatives must have authority to act on behalf of their business."
              }
            }
          ]
        }}
      />

      <div style={containerStyle}>
        {/* Header */}
        <div style={headerStyle}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
            <span style={{ fontSize: '40px', marginRight: '16px' }}>⚖️</span>
            <h1 style={{ margin: 0, fontSize: '48px', fontWeight: '300' }}>
              Terms of Service
            </h1>
          </div>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '400', opacity: 0.9 }}>
            Legal agreement governing your use of the Revfer platform and community.
          </h2>
          <div style={{ 
            display: 'inline-block', 
            marginTop: '16px',
            padding: '8px 16px',
            backgroundColor: 'rgba(255,255,255,0.2)',
            borderRadius: '16px',
            fontSize: '14px'
          }}>
            Effective Date: June 4, 2025
          </div>
        </div>

        {/* Quick Navigation */}
        <div style={paperStyle}>
          <h3 style={{ marginBottom: '16px', color: '#d32f2f' }}>
            Quick Navigation
          </h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {sections.map((section) => (
              <span
                key={section.id}
                style={{
                  ...chipStyle,
                  backgroundColor: expandedSection === section.id ? section.color : '#f5f5f5',
                  color: expandedSection === section.id ? 'white' : '#666',
                  border: expandedSection === section.id ? 'none' : '1px solid #e0e0e0'
                }}
                onClick={() => setExpandedSection(section.id)}
              >
                {section.icon} {section.title}
              </span>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div>
          {sections.map((section) => (
            <div key={section.id} style={accordionStyle}>
              <div
                style={{
                  ...accordionHeaderStyle,
                  backgroundColor: expandedSection === section.id ? '#f5f5f5' : '#fafafa'
                }}
                onClick={() => handleAccordionToggle(section.id)}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ fontSize: '24px', marginRight: '12px', color: section.color }}>
                    {section.icon}
                  </span>
                  <h3 style={{ margin: 0, fontSize: '20px' }}>
                    {section.title}
                  </h3>
                </div>
                <span style={{ fontSize: '20px', color: '#666' }}>
                  {expandedSection === section.id ? '−' : '+'}
                </span>
              </div>
              {expandedSection === section.id && (
                <div style={accordionContentStyle}>
                  {section.content}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Footer Actions */}
        {showSection &&
         <div style={{ ...paperStyle, backgroundColor: '#f5f5f5', marginTop: '32px' }}>
         <h3 style={{ marginBottom: '16px', color: '#d32f2f' }}>
           Questions About These Terms?
         </h3>
         <p style={{ marginBottom: '16px' }}>
           We're here to help you understand your rights and obligations. 
           Contact us if you need clarification on any provision.
         </p>
         <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
           <button 
             style={primaryButtonStyle}
             onClick={() => window.location.href = 'mailto:legal@revfer.com?subject=Terms of Service Question'}
           >
             Contact Legal Team
           </button>
           <button 
             style={outlinedButtonStyle}
             onClick={() => window.open('/legal/privacy-policy', '_blank')}
           >
             View Privacy Policy
           </button>
           <button 
             style={outlinedButtonStyle}
             onClick={() => alert('PDF download will be available soon. You can print this page or save as PDF using your browser.')}
           >
             Download Terms PDF
           </button>
         </div>
       </div>
        }

        {/* Acknowledgment */}
        <div style={{ ...paperStyle, backgroundColor: '#ffebee', color: '#d32f2f', marginTop: '16px' }}>
          <h4 style={{ marginBottom: '8px' }}>
            ⚠️ Acknowledgment Required
          </h4>
          <p style={{ margin: 0, fontSize: '14px' }}>
            By using Revfer, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service 
            and our Privacy Policy. If you do not agree to these terms, you must not use our services.
          </p>
        </div>
      </div>
    </>
  );
};

export default TermsOfServicePage;